module.exports = "../dist/frontend/icons/benefits/green/user-valid.svg?e9e3149ff9712710f2d746de0fa1806d";